export default __webpack_public_path__ + "static/media/ike_R_Blanco.92c42a8b.svg";